module.exports = __webpack_public_path__ + "static/img/wx-9.63f76a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx-9.png
// module id = ra6U
// module chunks = 10